import { useEffect, useState } from "react"
import { genericEntityService } from "../../../../services/genericEntityService";
import { useTranslation } from "react-i18next";
import { M_Select, M_CheckBox } from "../../../../M_Components";
import { useErrorHandler } from "../../shared/errorHandler";


const RelationForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();
    const { handleHttpError } = useErrorHandler();
    const [entities, setEntities] = useState([]);

    const selectedEntity = entities
        .find(e => e.EntityId === Number(field.secondaryEntityId));


    useEffect(() => {
        genericEntityService.getEntities()
            .then(function (response) {
                const nonExtensionEntities = [...response.data].filter(t => t.ExtendedEntity === null);
                setEntities(nonExtensionEntities);
            })
            .catch(function (error) {
                handleHttpError(error);
            })
    }, []);


    const handleChange = (property, value) => {
        propertyChangeCallback(property, value)
    }

    return (
        <>
            <div className="field-two-columns">
                <M_Select
                    label={t("NgeEntity")}
                    value={field.secondaryEntityId ?? ""}
                    options={entities.map(el => ({
                        label: el.Code,
                        value: el.EntityId
                    })
                    )}
                    noNone
                    required
                    disabled={field.fieldId !== null}
                    onChange={(e) => handleChange("secondaryEntityId", Number(e.target.value))}
                />
            </div>
            <div className="field-two-columns">
                <M_Select
                    multiple
                    label={t("NgeFieldsInRelation")}
                    value={field.secondaryEntityFields ?? []}
                    options={
                        selectedEntity?.Fields?.map(el => ({
                            label: el.Code,
                            value: el.FieldId
                        })) ?? []
                    }
                    noNone
                    disabled={field.secondaryEntityId === null || field.secondaryEntityId === undefined || !canEdit}
                    required
                    onChange={(e) => handleChange("secondaryEntityFields", e.target.value)}
                />
            </div>
            <div className="field-one-columns">
                <M_CheckBox
                    className="field-one-columns"
                    label={t("NgeAllowMultiple")}
                    checked={field.allowMultiple ?? false}
                    required
                    disabled={!canEdit}
                    onChange={(e) => handleChange("allowMultiple", e.target.checked)}
                />
            </div>
        </>
    )
}

export default RelationForm;